import './Brand.css';

interface BrandProps {
  team?: string;
  version?: string;
  compact?: boolean;
}

export function Brand({ team = 'Aurora FC · U12', version = 'v2026.4', compact = false }: BrandProps) {
  return (
    <div className={`brand ${compact ? 'brand--compact' : ''}`.trim()}>
      <div className="brand__mark">4C</div>
      {!compact && (
        <div className="brand__name">
          <b>FourCornerModel</b>
          <span className="brand__sep">·</span>
          <i>{team}</i>
          <span className="brand__sep">·</span>
          <span className="brand__version">{version}</span>
        </div>
      )}
    </div>
  );
}
